import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/app/app';

let container = document.getElementById('webfinder');
if (container) ReactDOM.render(<App />, document.getElementById('webfinder'));